import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useI18nTl from '@/hooks/useI18nTl'
import { ArrowRight } from '@element-plus/icons-vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  modelValue: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: '',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {

const props = __props




const { tl } = useI18nTl('Base')

const title = computed(
  () => {
    if (props.title && props.title != '') return props.title
    return tl('advancedSettings')
  }
)
const toggle = () => {
  emit('update:modelValue', !props.modelValue)
}

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "ButtonCom",
    class: "el-button el-button--primary is-link advanced-settings-btn",
    type: "primary",
    link: "",
    onClick: toggle
  }, [
    _createTextVNode(_toDisplayString(_unref(title)) + " ", 1),
    _createVNode(_component_el_icon, {
      class: _normalizeClass({ 'is-rotate': __props.modelValue })
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ArrowRight))
      ]),
      _: 1
    }, 8, ["class"])
  ], 512))
}
}

})